import type { ReactNode } from "react";

/**
 * The action chip for Banner's `action` slot, matching the design
 * system's own "WithAction" story. It inherits the banner's text color and is
 * transparent (outlined), so it keeps exactly the banner's contrast on every
 * variant and theme. (A design-system Button brings its own neutral text color,
 * and a lighter fill behind the chip drops tinted dark-mode text below 4.5:1.)
 *
 * Candidate for anthm-design as Banner.Action (design-system gaps,
 * docs/design/web/WEB_PARITY_PLAN.md).
 */
export function BannerAction({ onClick, children }: Readonly<{ onClick: () => void; children: ReactNode }>) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="btn-focus-ring inline-flex cursor-pointer items-center whitespace-nowrap rounded-md border border-current/40 px-2 py-0.5 text-xs font-semibold transition-colors hover:border-current hover:underline"
    >
      {children}
    </button>
  );
}
